import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
import { Types, Pais } from './types';

export const INITIAL_STATE: Pais = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): Pais {
	return produce(state, draft => {
		switch (action.type) {
			case Types.PAIS: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.PAIS_SUCCESS: {
				draft.data = action.payload;
				draft.status = 200;
				break;
			}

			case Types.PAIS_FAILURE: {
				draft.status = 400;
				break;
			}
			case Types.PAIS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
